<ng-container *ngIf="route.snapshot.data?.curd == CRUD_COMPONENT.create">

    <div class="wrap_close text-center mt-5">
        <!-- // import app-close -->
        <app-close routerLink="/"></app-close>
    </div>

    <div class="advertiser_class position-relative" >

        <!-- // import app-loader -->
        <app-loader [sm]="true" size="fa-8x" *ngIf="IsLoading"></app-loader>    
    
        <h4 class="sub_title color_black bold text_under text-center mb-3">اضافة عقار</h4>
    
        <div class="wrap_controls_checkbox text-center d-flex align-items-start align-items-sm-center justify-content-center flex-column flex-sm-row">
            <div class="wrap_control d-inline-block">
                <label 
                    [for]="CREATION_TYPE.Rega"
                    class="d-flex align-items-center justify-content-center pointer color_white">
                    <input 
                        type="radio"
                        class="d-none"
                        name="creationType"
                        [id]="CREATION_TYPE.Rega"
                        [checked]="CreationType == CREATION_TYPE.Rega"
                        (click)="selectCreationType(CREATION_TYPE.Rega)" 
                    />
                    <span class="checkmark"></span>
                    <span class="checkmark_name label_lg_bold color_white">اضافة العقار</span>
                </label>
            </div>
            <div class="wrap_control d-inline-block mb-3 mb-sm-0" *ngIf="!RegaValue">
                <label 
                    [for]="CREATION_TYPE.Saeei"
                    class="d-flex align-items-center justify-content-center pointer color_white">
                    <input
                        type="radio"
                        class="d-none"
                        name="creationType"
                        [id]="CREATION_TYPE.Saeei"
                        [checked]="CreationType == CREATION_TYPE.Saeei"
                        (click)="selectCreationType(CREATION_TYPE.Saeei)" 
                    />
                    <span class="checkmark"></span>
                    <span class="checkmark_name label_lg_bold color_white">خيارات اخري</span>
                </label>
            </div>            
        </div>
    
        <div class="wrap_box_toggle">
            <ng-container [ngSwitch]="CreationType">
                <ng-container *ngIf="!RegaValue">
                    <form 
                        [formGroup]="Form" 
                        *ngSwitchCase="CREATION_TYPE.Rega"
                    >
                        <div class="wrap_box">
                            <app-label [title]="UserDefinitions?.title"></app-label>
                            <app-pop-overs-title
                                class="ms-2"
                                title="تنبية هام!"
                                [content]="UserDefinitions?.title + ' بحسب بيانات الملف الشخصي '"
                            >
                            </app-pop-overs-title>                            
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    name="idNumber"
                                    matchNumbersOnly
                                    [limitCharacters]="10"
                                    formControlName="idNumber"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                >
                                </app-input-field>
                            </div>
                        </div>      
                        <div class="wrap_box">
                            <app-label title="رقم ترخيص الإعلان"></app-label>
                            <div class="wrap_input">
                                <app-input-field
                                    type="text"
                                    matchNumbersOnly
                                    [name]="'adNumber'"
                                    parseArabicToEnglish                            
                                    [limitCharacters]="10"    
                                    formControlName="adNumber"
                                    placeholder="... اكتب هنا"
                                    [validatorsErrorMsg]="true"
                                >
                                </app-input-field>
                            </div>            
                        </div>
                        <ng-container *ngFor="let err of ErrorsMsg">
                            <app-validation-input 
                                [text]="err?.msg"
                                class="my-4 text-center"
                            >
                            </app-validation-input>
                        </ng-container>
                    </form>
                </ng-container>
                <div class="d-flex align-items-start flex-column p-3" *ngSwitchCase="CREATION_TYPE.Saeei">
                    <ng-container *ngFor="let bundle of listOfBundledAds">
                        <label 
                            [for]="bundle.type"
                            class="d-flex align-items-center justify-content-center pointer mb-4 main_color">
                            <input
                                type="radio"
                                class="d-none"
                                name="bundledAds"
                                [id]="bundle.type"
                                [checked]="BundledAdsType == bundle.type"
                                (change)="selectBundleAdsType(bundle.type)"
                            />
                            <span class="checkmark"></span>
                            <span class="checkmark_name label_lg_bold">{{bundle.title}}</span>
                        </label>
                    </ng-container>
                    <!-- <p class="label_lg_bold text-center pt-5">
                        يمكنك المتابعة لاضافة تفاصيل العقار
                        تنصحك ساعي باضافة صور للعقار وتفاصيل دقيقة تمكن
                        المستخدمين من التعرف اكثر عما تريد عرضه
                    </p> -->
                </div>
                <div *ngIf="RegaValue">
                    <p class="label_lg_bold ">
                        سيتم اعتماد البيانات التالية كبيانات اساسية و بامكانك اضافة المزيد...
                    </p>
                    <hr>
                    <ul class="list_of_rega_value custom_scroll md">
                        <li class="label_lg_normal mb-2">
                            <span class="me-1 label_lg_bold">اسم المالك:</span> {{RegaValue?.advertiserName}}
                        </li>
                        <li class="label_lg_normal mb-2">
                            <span class="me-1 label_lg_bold">نوع التعاقد:</span> {{RegaValue?.advertisementType}}
                        </li>
                        <li class="label_lg_normal mb-2">
                            <span class="me-1 label_lg_bold">مساحة العقار:</span> {{RegaValue?.propertyArea}}
                        </li>
                        <li class="label_lg_normal mb-2">
                            <span class="me-1 label_lg_bold">سعر العقار:</span> {{RegaValue?.propertyPrice}}
                        </li>
                        <li class="label_lg_normal mb-2">
                            <span class="me-1 label_lg_bold">نوع العقار:</span> {{RegaValue?.propertyType}}
                        </li>  
                        <li class="label_lg_normal mb-2">
                            <span class="me-1 label_lg_bold">حالة العقار:</span> {{RegaValue?.propertyAge}}
                        </li>
                    </ul>
                </div>
            </ng-container>
        </div>

        <div class="text-center">
            <a class="a_none main_color d-flex align-items-center justify-content-center" href="https://wa.me/+966530107471" target="_blank">
                <span class="text_under label_lg_bold">التواصل مع الدعم الفني</span>
                <i class="fa-brands fa-whatsapp fa-2x ms-2"></i>
            </a>
        </div>
    
        <div class="wrap_btn text-center mt-5">
            <app-btn 
                [submit]="true" 
                [title]="BtnTitle"
                [call]="BtnHandle"
                [style]="{width: '90%'}"
                [disabled]="disableBtn || IsLoading" 
            >
            </app-btn>
        </div>  
    
    </div>    
</ng-container>